import { render, staticRenderFns } from "./Tiles.vue?vue&type=template&id=34145926&"
import script from "./Tiles.vue?vue&type=script&lang=js&"
export * from "./Tiles.vue?vue&type=script&lang=js&"
import style0 from "./Tiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports